import { combineReducers } from "redux";
import {
  fetchCollectionDetails,
  fetchCollections,
  fetchCreators,
  fetchDashboard,
  fetchDashboardBanners,
  fetchDashboardHallFrameInfo,
  fetchDashboardInfo,
  fetchHallOfFrameArtist,
  fetchHallOfFrameArtwork,
  fetchHallOfFrameCollector,
  fetchMarketPlaceNFT,
  fetchMoreCollections,
  fetchMoreCreators,
  fetchMoreMarketPlaceNFT,
  fetchMoreRentalProperties,
  fetchPagination,
  fetchProfileInfo,
  fetchRentalProperties,
  fetchTopCollection,
  fetchTopNFT,
  updateCollection,
} from "./auth.reducer";
import {
  fetchAuthData,
  fetchCategoryList,
  fetchCollectionList,
  fetchNewNFTId,
  fetchNonce,
  fetchResponseFailed,
  fetchUpdatedNFTId,
  fetchUserProfile,
} from "./defi.reducer";
import {
  fetchCategory,
  fetchCollectedNFT,
  fetchCollectionNFT,
  fetchInvestPoolSummary,
  fetchIsFollow,
  fetchIsLiked,
  fetchLanguage,
  fetchLikedNFT,
  fetchLikesCount,
  fetchNFTEditionHistory,
  fetchNewCollection,
  fetchNotifications,
  fetchProfile,
  fetchProfileBanner,
  fetchRentalEarnings,
  fetchRentalSummary,
  fetchRewardClaimSummary,
  fetchSecondaryMarketplaceMetrics,
  fetchSingleNFTDetails,
  fetchTransactionHistory,
  fetchUserDraftNFT,
  fetchUserNFT,
  fetch_twitter_access_token,
  isLoader,
  isRewardClaimed,
  updateProfile,
  verified_by_instagram,
  verified_by_twitter,
  fetchAmenitiesById,
} from "./user.reducer";
import {
  fetchNFTContractInstance,
  fetchNetworkId,
  fetchWeb3Data,
} from "./web3.reducer";

const rootReducer = combineReducers({
  fetchLanguage,
  fetchIsLiked,
  fetchLikesCount,
  fetchSingleNFTDetails,
  fetchUserDraftNFT,
  fetchNewCollection,
  fetchCategoryList,
  fetchCollectionList,
  fetchNewNFTId,
  fetchAuthData,
  fetchNonce,
  fetchNFTContractInstance,
  fetchNetworkId,
  fetchDashboardBanners,
  fetchDashboardInfo,
  fetchDashboard,
  fetchWeb3Data,
  fetchCategory,
  fetchDashboardHallFrameInfo,
  updateProfile,
  fetchUserNFT,
  fetchCreators,
  fetchPagination,
  fetchMoreCreators,
  fetchMarketPlaceNFT,
  fetchMoreMarketPlaceNFT,
  fetchRentalProperties,
  fetchMoreRentalProperties,
  fetchCollections,
  fetchCollectionDetails,
  fetchUserProfile,
  fetchProfile,
  fetchResponseFailed,
  fetchMoreCollections,
  updateCollection,
  fetchIsFollow,
  fetchTopNFT,
  fetchTopCollection,
  fetchLikedNFT,
  fetchCollectedNFT,
  fetchCollectionNFT,
  fetchRentalEarnings,
  fetchNFTEditionHistory,
  fetchNotifications,
  fetchProfileBanner,
  fetchProfileInfo,
  fetchUpdatedNFTId,
  fetchHallOfFrameCollector,
  fetchHallOfFrameArtwork,
  fetchHallOfFrameArtist,
  verified_by_instagram,
  fetch_twitter_access_token,
  verified_by_twitter,
  isRewardClaimed,
  isLoader,
  fetchRewardClaimSummary,
  fetchInvestPoolSummary,
  fetchTransactionHistory,
  fetchSecondaryMarketplaceMetrics,
  fetchRentalSummary,
  fetchAmenitiesById,
});

export default rootReducer;
